"use client"

import { Flex, Link } from "@chakra-ui/react";
import { ButtonGroup, IconButton, Pagination } from "@chakra-ui/react"
import { LuChevronLeft, LuChevronRight } from "react-icons/lu"


export default function ({ options = {} }) {
  const {
    currentPage,
    itemsPerPage,
    totalItems,
    totalPages,
    hasNextPage,
    hasPrevPage
  } = options;

  return (
    <Flex justifyContent="center" py="10">
      <Pagination.Root defaultPage={1} count={totalItems} pageSize={itemsPerPage} page={currentPage}>
        <ButtonGroup variant="ghost" size="sm">
          { hasPrevPage && (
            <Pagination.PrevTrigger asChild>
              <IconButton
                as={Link}
                href={`?page=${parseInt(currentPage) - 1}`}
                title={`Ir para página ${parseInt(currentPage) - 1}`}
                borderWidth="1px"
                borderColor="gray.300"
                rounded="sm"
              >
                <LuChevronLeft />
              </IconButton>
            </Pagination.PrevTrigger>
          )}

          <Pagination.Items
            borderWidth="1px" borderColor="gray.300" rounded="sm"
            render={(page) => (
              <IconButton
                as={Link}
                href={`?page=${page.value}`}
                title={`Ir para página ${page.value}`}
                variant={{ base: "ghost", _selected: "outline" }}
                bgColor={currentPage === page.value.toString() ? 'gray.200' : ''}>
                {page.value}
              </IconButton>
            )}
          />

          { hasNextPage && (
            <Pagination.NextTrigger asChild>
              <IconButton
                as={Link}
                href={`?page=${parseInt(currentPage) + 1}`}
                title={`Ir para página ${parseInt(currentPage) + 1}`}
                borderWidth="1px"
                borderColor="gray.300"
                rounded="sm"
              >
                <LuChevronRight />
              </IconButton>
            </Pagination.NextTrigger>
          )}
        </ButtonGroup>
      </Pagination.Root>
    </Flex>
  )
}
